<template>
  <el-dialog
    title="设备实时报警"
    :visible.sync="showDialog"
    :modal-append-to-body="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
    :class="alarmNumber == 0 ? '' : 'dialogClass'"
    width="30%"
  >
    <div class="dialog-box">
      <div class="item-box" v-for="(item, index) in tableData" :key="index">
        <div class="content-box">
          {{ item.emAlarmName }}发生了{{
            $Common.getDataName(emAlarmTypeList, item.emAlarmType)
          }},通道编号:{{ item.emChannalNo }}
        </div>
        <div class="time-box">
          {{ $Common.dateFormatDateTwo(item.emAlarmTime) }}
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    dialogInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    //这里存放数据
    return {
      tableData: [],
      websock: null,
      alarmNumber:0
    };
  },
  //监控data中的数据变化
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dataInfo = this.dialogInfo;
        this.getInfo();
      }
    }
  },
  //计算属性，类似于data概念
  computed: {
    emDeviceBrandList() {
      return this.$store.state.select.emDeviceBrandList;
    },
    emAlarmTypeList() {
      return this.$store.state.select.emAlarmTypeList;
    }
  },
  //方法集合
  methods: {
    close() {
      this.websock.close();
      this.$emit("close");
    },
    async getInfo() {
      this.alarmNumber = 0
      let res = await this.$Http.getMonitoringAlarmTop(this.dataInfo);
      if (res.code == 200) {
        this.tableData = res.data || [];
        console.log(this.tableData, "----------");
        // this.initWebSocket();
      } else {
        this.tableData = [];
      }
    },
    initWebSocket() {
      //初始化weosocket
      let params =
        "?schoolId=" +
        this.dataInfo.schoolId +
        "&deviceNum=" +
        this.dataInfo.emDeviceNum +
        "&type=1";
      let wsuri =
        this.$store.state.config.wsIpConfig +
        "/webscoket/environment/monitor/ty" +
        params;
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonerror() {
      //连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) {
      let res = JSON.parse(e.data);
      res.forEach((element) => {
        this.tableData.unshift(element);
      });
      let indexNumber = res.length > 50 ? 50 : 50 - res.length;
      this.tableData.splice(indexNumber, res.length);
      this.alarmNumber = this.alarmNumber + 1
    },
    websocketclose(e) {
      //关闭
      console.log("断开连接", e);
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {
  },
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scope>
.dialog-box {
  width: 100%;
  height: 500px;
  overflow-y: scroll;
  .item-box {
    width: 100%;
    height: 46px;
    padding: 0px 20px 0px 10px;
    // background-color:	#f9f9f9;
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0.5px;
    border-color: rgba(153, 153, 153, 0.6);
    border-style: none none dashed none;
    .content-box {
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
    }
    .time-box {
      font-size: 12px;
      color: rgba(187, 187, 187, 1);
    }
  }
}
.dialogClass {
  .el-dialog{
    border-radius: 10px;
    border:1px solid red;
    // box-shadow: 3px 3px 5px red inset;
    box-shadow: -10px -10px  0px #666; 
    box-shadow:  0px -3px 5px red inset,
           -3px 0px 5px  red inset,
           3px 0px 5px  red inset,
          0px 3px 5px  red inset;
    animation: fade 600ms infinite;
      -webkit-animation: fade 600ms infinite;
  }
}
@keyframes fade {
    from {
      border:1px solid rgba(255,0,0,1);
  // box-shadow: 3px 3px 5px rgba(255,0,0,1) inset;
  box-shadow:  0px -3px 5px red inset,
				 -3px 0px 5px  red inset,
				 3px 0px 5px  red inset,
				0px 3px 5px  red inset;
    }
    50% {
      border:1px solid rgba(255,0,0,0.5);
  // box-shadow: 3px 3px 5px rgba(255,0,0,0.4) inset;
  box-shadow:  0px -3px 5px rgba(255,0,0,0.4) inset,
				 -3px 0px 5px  rgba(255,0,0,0.4) inset,
				 3px 0px 5px  rgba(255,0,0,0.4) inset,
				0px 3px 5px  rgba(255,0,0,0.4) inset;
    }
    to {
      border:1px solid rgba(255,0,0,1);
  // box-shadow: 3px 3px 5px rgba(255,0,0,1) inset;
  box-shadow:  0px -3px 5px red inset,
				 -3px 0px 5px  red inset,
				 3px 0px 5px  red inset,
				0px 3px 5px  red inset;
    }
}

@-webkit-keyframes fade {
    from {
      border:1px solid rgba(255,0,0,1);
  // box-shadow: 3px 3px 5px rgba(255,0,0,1) inset;
  box-shadow:  0px -3px 5px red inset,
				 -3px 0px 5px  red inset,
				 3px 0px 5px  red inset,
				0px 3px 5px  red inset;
    }
    50% {
      border:1px solid rgba(255,0,0,0.4);
  // box-shadow: 3px 3px 5px rgba(255,0,0,0.4) inset;
  box-shadow:  0px -3px 5px rgba(255,0,0,0.4) inset,
				 -3px 0px 5px  rgba(255,0,0,0.4) inset,
				 3px 0px 5px  rgba(255,0,0,0.4) inset,
				0px 3px 5px  rgba(255,0,0,0.4) inset;
    }
    to {
      border:1px solid rgba(255,0,0,1);
  // box-shadow: 3px 3px 5px rgba(255,0,0,1) inset;
  box-shadow:  0px -3px 5px red inset,
				 -3px 0px 5px  red inset,
				 3px 0px 5px  red inset,
				0px 3px 5px  red inset;
    }
}
</style>
